/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MiningStatisticsResponse { 
    averageHashrateTenMinutes: number;
    averageHashrateHour: number;
    averageHashrateDaily: number;
    totalWorkers: number;
    activeWorkers: number;
    offlineWorkers: number;
    inactiveWorkers: number;
}

